module.exports = __webpack_public_path__ + "static/img/resource_widget_1.2243c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/resource_widget_1.png
// module id = ZwW8
// module chunks = 11